import { BUSINESS } from "@/lib/business";

// Real reviews are not wired in yet. To stay honest, this component renders
// a CTA pointing customers to the Google Business Profile rather than
// fabricated testimonials. Do not add hard-coded reviews here.
export function Testimonials(_props: { count?: number; city?: string }) {
  return (
    <div className="rounded-xl border border-border bg-card p-6 text-center">
      <p className="text-foreground">
        Read real customer feedback for Phoenix Plumbing Co. on Google.
      </p>
      <div className="mt-4 flex flex-wrap justify-center gap-3">
        <a
          href={`https://www.google.com/maps?cid=${BUSINESS.cid}`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center rounded-md bg-primary text-primary-foreground px-5 py-3 font-extrabold hover:opacity-90"
        >
          Read our Google reviews
        </a>
        <a
          href={BUSINESS.reviewLink}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center rounded-md border-2 border-primary text-primary px-5 py-3 font-extrabold hover:bg-primary/10"
        >
          Leave a review
        </a>
      </div>
    </div>
  );
}